var appearing = [{
  initialAttr: {
    opacity: 0
  },
  finalAttr: {
    opacity: 1
  },
  slot: 'plot'
}],
    updating = [{
  slot: 'plot',
  startEnd: {
    start: 0,
    end: .5
  }
}],
    disappearing = [{
  slot: 'intial'
}];
export default {
  "*.legend.legend": function legendLegend() {
    return {
      "legendGroup.appearing": appearing,
      "legendGroup.updating": updating,
      "legendGroup.disappearing": disappearing,
      "scroller.appearing": appearing,
      "scroller.updating": updating,
      "scroller.disappearing": disappearing
    };
  }
};